var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import FocusGuard from "src/decidim/focus_guard";
export default class Menu {
  constructor(opts = {}) {
    __publicField(this, "openedItem");
    __publicField(this, "triggerElement");
    this.rootElement = document.querySelector(opts.rootElement);
    this.navItemSelector = opts.navItem;
    this.focusGuard = new FocusGuard(this.rootElement);
  }
  bindEvents() {
    this._handleNavItemClick = this._handleNavItemClick.bind(this);
    this._handleNavItemFocusIn = this._handleNavItemFocusIn.bind(this);
    this._handleClickOutside = this._handleClickOutside.bind(this);
    this._handleKeyboardEvent = this._handleKeyboardEvent.bind(this);
  }
  initialize() {
    if (this.rootElement) {
      this.bindEvents();
      this.initListeners();
    }
  }
  initListeners() {
    if (this.rootElement) {
      this.rootElement.addEventListener("click", this._handleNavItemClick);
      this.rootElement.addEventListener("focusin", this._handleNavItemFocusIn);
      document.addEventListener("click", this._handleClickOutside);
      document.addEventListener("keyup", this._handleKeyboardEvent);
    }
  }
  close() {
    if (this.openedItem) {
      this.openedItem.classList.remove("open");
      const triggerButton = this.openedItem.querySelector("button");
      triggerButton.setAttribute("aria-expanded", "false");
      triggerButton.setAttribute("aria-label", triggerButton.dataset.expandMenuText);
    }
    this.openedItem = null;
  }
  openSubmenu(event) {
    const currentItem = event.target.closest(this.navItemSelector);
    const triggerButton = event.target.closest("button");
    triggerButton.setAttribute("aria-expanded", "true");
    triggerButton.setAttribute("aria-label", triggerButton.dataset.collapseMenuText);
    currentItem.classList.toggle("open", currentItem !== this.openedItem);
    this.openedItem = currentItem !== this.openedItem ? currentItem : null;
    if (this.openedItem) {
      const submenuWrapper = this.openedItem.querySelector(".main-nav__item-wrapper");
      this.focusGuard.container = submenuWrapper;
      this.focusGuard.trap(this.openedItem.querySelector("ul"), event.target.closest("button"));
      submenuWrapper.querySelector("a").focus();
      this.triggerElement = event.target.closest("button");
    } else {
      this.focusGuard.disable();
    }
  }
  _toggleItem(event) {
    if (!event.target.closest(".main-nav__button")) {
      return;
    }
    const element = event.target.closest(this.navItemSelector);
    const triggerElement = $(event.target);
    const triggerButton = triggerElement.parents("[data-toggle-menu]").length || triggerElement.closest("button");
    $(this.navItemSelector).each((_, item) => {
      if (item !== element) {
        $(item).removeClass("open");
      }
    });
    if (!triggerButton) {
      return;
    }
    this.openSubmenu(event);
  }
  _handleClickOutside(event) {
    if (!this.rootElement.contains(event.target)) {
      this.close();
    }
  }
  _handleKeyboardEvent(event) {
    if (event.code === "Escape" && this.rootElement.contains(document.activeElement)) {
      this.close();
      this.triggerElement && this.triggerElement.focus();
      this.triggerElement = null;
    }
  }
  _handleNavItemClick(event) {
    this._toggleItem(event);
  }
  _handleNavItemFocusIn(event) {
    if (this.openedItem && !this.openedItem.contains(event.target)) {
      this.close();
    }
  }
}
